export const DEFAULT_BACKGROUND_COLOR = '#000' // We don't have a variable for this color yet
export const DEFAULT_FOREGROUND_COLOR = 'var(--color_primary_300, #D0B2FF)'
export const DEFAULT_TEXT_COLOR = 'var(--color_neutral_0)'
